import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { everyTime, toBit, toInt } from 'components/TimeTable'

const initialState = {
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  isLoading: false,
  loadingError: undefined,
  adGroups: [],
  form: {
    impressionAll: true,
    weeklySchedule: everyTime,
  },
  preview: {
    impressionAll: true,
    weeklySchedule: everyTime,
  },
}

export const showAdGroupWeeklyScheduleEdit = createAxiosThunk(
  'dashboard/showAdGroupWeeklyScheduleEdit',
  adGroupIds => api.ad.getAdGroups(adGroupIds)
)

export const updateAdGroupsWeeklySchedule = createAxiosThunk(
  'dashboard/updateAdGroupsWeeklySchedule',
  (noArgs, { getState }) => {
    const {
      adGroups,
      form: { impressionAll, weeklySchedule },
    } = getState().dashboard.operation.adGroupWeeklyScheduleEdit
    return api.ad.patchAdGroupsWeeklySchedule({
      adGroupIds: adGroups.map(({ id }) => id),
      weeklySchedule: toInt(impressionAll ? everyTime : weeklySchedule),
    })
  }
)

const adGroupWeeklyScheduleEditSlice = createSlice({
  name: 'dashboard/adGroupWeeklyScheduleEdit',
  initialState,

  reducers: {
    hideAdGroupWeeklyScheduleEdit: () => initialState,
    setImpressionAll: (state, { payload }) => {
      state.form.impressionAll = payload
    },
    setWeeklySchedule: (state, { payload }) => {
      state.form.weeklySchedule = payload
    },
    showPreview: state => {
      state.preview.impressionAll = state.form.impressionAll
      state.preview.weeklySchedule = state.form.weeklySchedule
      state.previewVisible = true
    },
    hidePreview: state => {
      state.previewVisible = false
    },
  },

  extraReducers: builder => {
    builder.addCase(showAdGroupWeeklyScheduleEdit.pending, state => {
      state.isLoading = true
      state.visible = true
    })

    builder.addCase(
      showAdGroupWeeklyScheduleEdit.rejected,
      (state, { payload }) => {
        state.loadingError = payload
        state.isLoading = false
      }
    )

    builder.addCase(
      showAdGroupWeeklyScheduleEdit.fulfilled,
      (state, { payload: { adGroupDtos } }) => {
        const adGroups = adGroupDtos.map(
          ({ id, name, impressionSchedule }) => ({
            id,
            name,
            impressionSchedule,
          })
        )
        state.adGroups = adGroups
        const hasSameValue =
          adGroups.length > 1 &&
          adGroups.every((value, index, array) => {
            const item = value.impressionSchedule
            const first = array[0].impressionSchedule
            return item.weeklySchedule === first.weeklySchedule
          })
        if (adGroups.length === 1 || hasSameValue) {
          const [first] = adGroups
          const {
            impressionSchedule: { weeklySchedule },
          } = first
          state.form.weeklySchedule = weeklySchedule
            ? toBit(weeklySchedule)
            : everyTime
          state.form.impressionAll =
            !weeklySchedule || toBit(weeklySchedule) === everyTime
        }
        state.isLoading = false
      }
    )

    builder.addCase(updateAdGroupsWeeklySchedule.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(updateAdGroupsWeeklySchedule.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(updateAdGroupsWeeklySchedule.rejected, state => {
      state.isSubmitting = false
    })
  },
})
export const {
  hideAdGroupWeeklyScheduleEdit,
  showPreview,
  hidePreview,
  setImpressionAll,
  setWeeklySchedule,
} = adGroupWeeklyScheduleEditSlice.actions
export default adGroupWeeklyScheduleEditSlice.reducer
